/* Footer email signup -> Klaviyo client subscriptions API (no app). POST https://a.klaviyo.com/client/subscriptions/?company_id=X
   with the revision header; 202 = success. States: idle, submitting (button busy), success (form replaced by the
   confirmation), error (inline, form kept), invalid email (inline). Honeypot field. Without a list id (TODO) the form
   shows the success UI and logs a console warning (08 A1). */
(() => {
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  function init(form) {
    if (form.dataset.smKlReady) return;
    form.dataset.smKlReady = '1';
    const input = form.querySelector('input[type="email"]');
    const btn = form.querySelector('button[type="submit"]');
    const hp = form.querySelector('.em-hp');
    const msg = form.querySelector('.em-msg');
    const cfg = (window.SM && window.SM.config && window.SM.config.klaviyo) || {};
    const say = (state, text) => { msg.dataset.state = state; msg.textContent = text || ''; msg.setAttribute('role', state === 'error' || state === 'invalid' ? 'alert' : 'status'); };
    const success = () => {
      const p = document.createElement('p');
      p.className = 'em-msg'; p.dataset.state = 'success'; p.setAttribute('role', 'status'); p.tabIndex = -1;
      p.textContent = msg.dataset.success || "Thanks, you're on the list.";
      form.replaceWith(p);
      p.focus({ preventScroll: true });
    };
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const email = (input.value || '').trim();
      if (!EMAIL.test(email)) { say('invalid', msg.dataset.invalid || 'Enter a valid email address.'); input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
      input.removeAttribute('aria-invalid');
      if (hp && hp.value) { success(); return; } // bot
      const listId = (cfg.listId || '').trim();
      if (!cfg.companyId || !listId || /^TODO/i.test(listId)) {
        console.warn('[Sunday Market] Klaviyo list id is not set (Theme settings > Klaviyo). Showing success UI without subscribing.');
        success();
        return;
      }
      btn.disabled = true; btn.setAttribute('aria-busy', 'true'); say('submitting', '');
      try {
        const res = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(cfg.companyId)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', revision: cfg.revision || '2024-10-15' },
          body: JSON.stringify({ data: { type: 'subscription', attributes: { profile: { data: { type: 'profile', attributes: { email } } }, custom_source: form.dataset.source || 'Footer signup' }, relationships: { list: { data: { type: 'list', id: listId } } } } }),
        });
        if (res.status === 202 || res.ok) {
          try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email }); } catch (err) {}
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'sign_up', method: 'footer' }); } catch (err) {}
          success();
          return;
        }
        throw new Error(`Klaviyo ${res.status}`);
      } catch (err) {
        say('error', msg.dataset.error || 'Something went wrong. Try again.');
        btn.disabled = false; btn.removeAttribute('aria-busy');
      }
    });
  }
  const run = () => document.querySelectorAll('[data-sm-klaviyo-form]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
